import axios from "axios";
import { API_URL } from "../utils/constant";
// import Cookies from "universal-cookie";
import {
  CODE_CREATED,
  CREATING_CODE_RECORD,
  LEAKEDCREDS_REQUESTS_FETCHED,
  LEAKED_SESSION_FETCHED_GRAPH,
  LEAKED_SESSION_FETCHED_TOTAL
} from "./index";
import { toastr } from "react-redux-toastr";
import $ from "jquery"
// import { toastr } from 'react-redux-toastr';

export const fetchLeakedCode = (props,dispatch , page , status , category,startDate,endDate,limit,search) => {
  if(props){
    axios
      .get(`${API_URL}/approved-code/${props}/delta?page=${page}&limit=${limit}&category=${category}&status=${status}&from=${startDate}&till=${endDate}&search=${search}`)
      .then((response) => {
        dispatch({
          type: "SET_LEAKED_CODE",
          data: response.data,
        });
      })
  }
};

export const fetchLeakedCodeUpdate = (props,dispatch,data,clear,p) => {
  if(props){
    axios
      .patch(`${API_URL}/approved-code/${props}/update`,data)
      .then((response) => {
        dispatch({
          type: "SET_LEAKED_CODE",
          data: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
          clear()
          fetchLeakedCode(props,dispatch,p,'all','all','','','','')
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      })
  }
};

export const fetchLeakedCodeDelete = (orgId,props,dispatch, p) => {
  if(props){
    axios
      .delete(`${API_URL}/approved-code/${orgId}/${props}/delete`)
      .then((response) => {
        dispatch({
          type: "SET_LEAKED_CODE",
          data: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
          fetchLeakedCode(orgId,dispatch,p,'all','all','','','','')
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      })
  }
};

export const fetchLeakedCodeAction = (props,dispatch , page , status , category ,data) => {
  if(props){
    axios
      .post(`${API_URL}/approved-code/${props}/action?page=${page}&category=${category}&status=${status}`,data)
      .then((response) => {
        dispatch({
          type: "SET_LEAKED_CODE",
          data: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      })
  }
};

export const fetchLeakedCodeGraph = (props,dispatch) => {
  if(props){
    axios
      .get(`${API_URL}/approved-code/${props}/graph`)
      .then((response) => {
        dispatch({
          type: LEAKED_SESSION_FETCHED_GRAPH,
          data: response.data,
        });
      })
  }
};

export const fetchLeakedCodeTotal = (props,dispatch) => {
  if(props){
    axios
      .get(`${API_URL}/approved-code/${props}/totals`)
      .then((response) => {
        dispatch({
          type: LEAKED_SESSION_FETCHED_TOTAL,
          data: response.data,
        });
      })
  }
};

export const createdLeakedCodeRecord = (props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/leakedcode`, {
        repoUrl: props.repoUrl,
        organisationId: props.organisationId,
        programmingLanguage: props.programmingLanguage,
        severityLevel: props.severityLevel,
        leakedCode: props.leakedCode,
        comments: props.comments,
        attachmentUrl: props.attachmentUrl,
        approved: true
      })
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${props.organisationId}?tab=source`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const createDarkWebRecord = (props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/darkweb`,props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const uploads3Url = (props,data) => {
  return new Promise((resolve, reject) => {
    if (!props) {
      reject(new Error('Invalid props object'));
      return;
    }
    axios
      .post(`${API_URL}/generateSignedUrl`, {
        fileName: props.upload.filename,
        fileType: props.type,
        folderName: data
      })
      .then((response) => {
        if (response.data.error) {
          reject(response.data.userMessage); 
        } else {
          resolve(response.data.data.fileUrl);
          uploadDarwebSigned(response.data.data.signedUrl,props)
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        reject(message); 
      });
  });
};

export const uploadDarwebSigned = (apiUrl, file) => {
  if (apiUrl && file) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      $.ajax({
        url: apiUrl,
        type: 'PUT',
        data: reader.result,
        processData: false,
        contentType: 'application/octet-stream',
        success: function(response) {
          if (response.error) {
            toastr.error('Error', response.userMessage);
          } else {
            toastr.success('Success', 'Image Upload');
          }
        },
        error: function(err) {
          var message = 'Some server error has occurred.';
          if (err.responseJSON && err.responseJSON.userMessage) {
            message = err.responseJSON.userMessage;
          }
          toastr.error('Error', message);
        }
      });
    };
  } else {
    toastr.error('Error', 'Invalid URL or file object');
  }
};


// export const uploadDarwebSigned = (apiUrl, file) => {
//   if (apiUrl && file) {
//     var formData = new FormData();
//     formData.append(file);
//     $.ajax({
//       url: apiUrl,
//       type: 'PUT',
//       data: formData,
//       processData: false, // Important: Don't process the data
//       contentType: false, // Important: Set content type to false
//       success: function(response) {
//         if (response.error) {
//           toastr.error('Error', response.userMessage);
//         } else {
//           toastr.success('Success', 'Image Upload');
//         }
//       },
//       error: function(err) {
//         var message = 'Some server error has occurred.';
//         if (err.responseJSON && err.responseJSON.userMessage) {
//           message = err.responseJSON.userMessage;
//         }
//         toastr.error('Error', message);
//       }
//     });
//   } else {
//     toastr.error('Error', 'Invalid URL or file object');
//   }
// };

export const createAppSToreRecord = (id,props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/${id}/queue/roguemobileapps/add`, props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${id}?tab=mobile`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};


export const createMalwareCredentials = (props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/getMalwareCredentials`, props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${props.organisationId}?tab=malware`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const createPii = (props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/pii-details`, props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${props.organisationId}?tab=pii`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const createBrandMention = (id,props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/${id}/queue/brandmentions/add`, props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${id}?tab=brand`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};


export const createStolenCrdentials = (props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/dehashed/search`, props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${props.organisationId}?tab=stolen`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const createCloudBucket = (props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/cloud-bucket-details`, props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${props.organisationId}?tab=cloud`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};


export const createPastbinSearch = (props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/pastebin/createPastebinRecordManually`, props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${props.organisationId}?tab=pastebin`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const createSocialMediaProfile = (props, clear, dispatch) => {
  if (props) {
    axios
      .post(`${API_URL}/createSocialMediaProfile`, props)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          clear();
          toastr.success("Success", response.data.userMessage);
          window.location.href = `/show-details/${props.organisationId}?tab=social`;
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: CODE_CREATED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const updateSourceCodeStatus = (_id, _falsePositive, _mitigated, domains, customerId, type, dispatch) => {
  axios
    .post(`${API_URL}/updateSourceCodeStatus`, {
      id: _id,
      isFalsePositive: _falsePositive,
      isMitigated: _mitigated,
      domains: domains,
      organisationId: customerId,
      type: type
    })
    .then((res) => {
      if (!res.data.error) {
        if(type == "removefalsePositive")
          toastr.success("SUCCESS", "Removed from False Positive");
        else
          toastr.success("SUCCESS", `${type == "falsePositive" ? "Marked as False Positive" : "Marked as Mitigated"}`);
        dispatch({
          type: "SET_LEAKED_CODE",
          data: res.data,
        });
      } else {
        toastr.error("ERROR", "SOMETHING WENT WRONG!");
      }
    })
    .catch((err) => {
      toastr.error("ERROR", "SOMETHING WENT WRONG!");
    });
}